<div class="box-title col-xs-12">
    <h3>Ciclo de facturación:<strong id="cicloFactura"> {{item?.fechaDesde}} hasta {{item?.fechaHasta}}</strong></h3>
    <p id="diasRestantes">{{item?.diasRestantes}}<span> restantes</span></p>
</div>